export const APPLICABLE = [
  { id: true, displayValue: 'Applicable' },
  { id: false, displayValue: 'Not Applicable' },
];
